<template>
  <div>
    <transition name="fade">
      <div :class="maskClasses" :style="maskStyle" v-show="visible" v-if="mask" @click="handleMask"></div>
    </transition>
    <div :class="wrapClasses" :style="wrapperStyle" @click="handleWrapClick">
      <transition :name="'move-' + placement">
        <div :class="classes" :style="computedMainStyles" v-show="visible">
          <div :class="contentClasses" ref="content">
            <slot name="more"></slot>
            <a class="ivu-drawer-close btn" v-if="closable" @click="close">
              <slot name="close">
                <i class="mng icon-cross-stroke"></i>
              </slot>
            </a>
            <div :class="[prefixCls + '-header']" v-if="showHead">
              <slot name="header">
                <div :class="[prefixCls + '-header-inner']">{{ title }}</div>
              </slot>
            </div>
            <div ref="drawerBody" :class="[prefixCls + '-body']" :style="styles">
              <slot></slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import util from '../../libs/util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  const prefixCls = 'ivu-drawer'

  export default {
    name: 'Drawer',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 256
      },
      closable: {
        type: Boolean,
        default: true
      },
      maskClosable: {
        type: Boolean,
        default: true
      },
      mask: {
        type: Boolean,
        default: true
      },
      maskStyle: {
        type: Object
      },
      wrapperStyle: {
        type: Object
      },
      mainStyle: {
        type: Object
      },
      styles: {
        type: Object
      },
      scrollable: {
        type: Boolean,
        default: false
      },
      placement: {
        validator(value) {
          return util.oneOf(value, ['left', 'right'])
        },
        default: 'right'
      },
      zIndex: {
        type: Number,
        default: 1000
      },
      className: {
        type: String
      },
      inner: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        prefixCls: prefixCls,
        visible: this.value,
        wrapShow: false,
        showHead: true
      }
    },
    computed: {
      wrapClasses() {
        return [
          `${prefixCls}-wrap`,
          {
            [`${prefixCls}-hidden`]: !this.wrapShow,
            [`${this.className}`]: !!this.className,
            [`${prefixCls}-no-mask`]: !this.mask,
            [`${prefixCls}-wrap-inner`]: this.inner
          }
        ]
      },
      computedMainStyles() {
        let style = {}

        if (!isNaN(this.width)) {
          const width = parseInt(this.width)

          const styleWidth = {
            width: width <= 100 ? `${width}%` : `${width}px`
          }

          Object.assign(style, styleWidth)
        } else {
          const styleWidth = {
            width: this.width
          }

          Object.assign(style, styleWidth)
        }

        Object.assign(style, this.mainStyle)

        return style
      },
      contentClasses() {
        return [
          `${prefixCls}-content`,
          {
            [`${prefixCls}-content-no-mask`]: !this.mask
          }
        ]
      },
      classes() {
        return [
          `${prefixCls}`,
          `${prefixCls}-${this.placement}`,
          {
            [`${prefixCls}-no-header`]: !this.showHead,
            [`${prefixCls}-inner`]: this.inner
          }
        ]
      },
      maskClasses() {
        return [
          `${prefixCls}-mask`,
          {
            [`${prefixCls}-mask-inner`]: this.inner
          }
        ]
      }
    },
    methods: {
      close() {
        this.visible = false
        this.$emit('input', false)
        this.$emit('on-close')
      },
      handleMask() {
        if (this.maskClosable && this.mask) {
          this.close()
        }
      },
      handleWrapClick(event) {
        // use indexOf,do not use === ,because ivu-modal-wrap can have other custom className
        const className = event.target.getAttribute('class')
        if (className && className.indexOf(`${prefixCls}-wrap`) > -1) this.handleMask()
      },
      updateScroller() {
        this.$emit('update-scroller')
      }
    },
    mounted() {
      if (this.visible) {
        this.wrapShow = true
      }

      let showHead = true

      if (this.$slots.header === undefined && !this.title) {
        showHead = false
      }

      this.showHead = showHead
      if (this.$refs.drawerBody) {
        addResizeListener(this.$refs.drawerBody, this.updateScroller)
      }
    },
    beforeDestroy() {
      removeResizeListener(this.$refs.drawerBody, this.updateScroller)
    },
    watch: {
      value(val) {
        this.visible = val
      },
      visible(val) {
        if (val === false) {
          this.timer = setTimeout(() => {
            this.wrapShow = false
            // this.removeScrollEffect()
          }, 300)
        } else {
          if (this.timer) clearTimeout(this.timer)
          this.wrapShow = true
          if (!this.scrollable) {
            // this.addScrollEffect()
          }
        }
        this.$emit('on-visible-change', val)
      },
      scrollable(val) {
        if (!val) {
          // this.addScrollEffect()
        } else {
          // this.removeScrollEffect()
        }
      },
      title(val) {
        if (this.$slots.header === undefined) {
          this.showHead = !!val
        }
      }
    }
  }
</script>
<style src="./drawer.less" lang="less"></style>



// WEBPACK FOOTER //
// src/components/drawer/drawer.vue